<template>
  <div class="refresh-modal">
    <modal-title title="Refresh Block" @close="$emit('close')" />
    <div class="version-info">
      <p v-if="documentVersionValid">
        <strong>Document Version:</strong> {{ $filters.long(documentVersion) }}
      </p>
      <p><strong>Latest Version:</strong> {{ $filters.long(latestVersion) }}</p>
    </div>
    <div class="main-actions">
      <button
        type="button"
        class="btn btn-primary bg-info"
        @click="$emit('update-block', contentBlock)"
      >
        Refresh Document from sharedo
      </button>
    </div>
  </div>
</template>
<script>
import ModalTitle from "@/components/common/modal/ModalTitle.vue";
import documentModel from "@/mixins/documentModel";
import { isValid } from "@/util/dateUtil";

export default {
  components: { ModalTitle },
  mixins: [documentModel],
  props: {
    contentBlock: {
      required: true,
    },
  },
  computed: {
    documentVersionValid: function() {
      return isValid(this.documentVersion);
    },
    documentVersion: function() {
      const block = this.documentModel.findContentControlBySystemName(
        this.contentBlock.systemName
      );

      return block[0].version.date;
    },
    latestVersion: function() {
      return this.contentBlock.versionDate;
    },
  },
  emits: ["update-block"],
};
</script>
<style lang="scss" scoped>
.version-info {
  font-size: 0.8rem;
  text-align: left;
}
.main-actions {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  & > button {
    margin-top: 10px;
  }
}
</style>
